export class IccImportFilters {
  selectedClientIds = [];
}
